export const unauthorizedMiddleware = {
    post(context: any): Promise<Response | void> {
        return new Promise<Response>((resolve) => {
            if (context.response.status === 401) {
                window.location.reload();
            }

            resolve(context.response);
        });
    },
};
